import { EmailOutlined } from '@mui/icons-material'
import { Box, Button, InputAdornment, TextField, Typography } from '@mui/material'
import React from 'react'
import { authService } from '../../../services/authService'
import { toast } from 'react-toastify'
import { STAGES } from '../Signup'
import { isValidEmail } from '../../../utility/validator'
import { useNavigate } from 'react-router-dom'

const EnterEmail = ({ userDetails, setUserDetails, isLoading, navigateToScreen }) => {
  const navigate = useNavigate()

  const sendOtp = async (e) => {
    e.preventDefault()

    if (!isValidEmail(userDetails.email)) {
      return
    }

    // create user and send otp just with email
    const res = await authService.sendOnboardingOtp({ email: userDetails.email })
    if (res.status) {
      navigateToScreen(STAGES.VERIFY_EMAIL)
    } else {
      toast.error('Something went wrong!')
    }
  }

  return (
    <Box
      component="form"
      className="onboardingForm"
      style={{
        marginBottom: 16,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        background: ' #fff',
        borderRadius: 12,
        boxShadow: '0 24px 64px #26214a1a',
        padding: '60px 60px',
      }}
      onSubmit={sendOtp}
    >
      <Typography
        variant="h5"
        color="textSecondary"
        style={{
          color: '#27104E',
          fontSize: '21px',
          marginBottom: '10px',
          fontWeight: '800',
        }}
      >
        Register Your Email
      </Typography>
      <Typography
        style={{ marginBottom: '30px', color: '#4E62BB', fontSize: '12px', textAlign: 'center' }}
      >
        Enter your email address to receive a verification code
      </Typography>

      <TextField
        style={{ borderColor: '#D6D9DE', borderRadius: '10px' }}
        onChange={(e) => setUserDetails((state) => ({ ...state, email: e.target.value }))}
        label="Email address"
        variant="outlined"
        color="primary"
        fullWidth
        type="email"
        value={userDetails.email}
        size="small"
        autoFocus
        className="inputsout"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <EmailOutlined style={{ fontSize: 16, color: '#8790B7' }} />
            </InputAdornment>
          ),
        }}
      />

      <Button
        fullWidth
        disabled={isLoading}
        color="primary"
        variant="contained"
        className="onboarding-btn"
        onClick={sendOtp}
        style={{ borderRadius: '9px' }}
        type="submit"
      >
        Send OTP
      </Button>

      <Typography
        style={{ marginTop: 24, fontSize: 14, cursor: 'pointer' }}
        color="primary"
        onClick={() => navigate('/login')}
      >
        Skip creating a company. <b>Log in instead.</b>
      </Typography>
    </Box>
  )
}

export default EnterEmail
